import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useSharedContext } from '@office-start/context-service';
import { queryCache, useQuery, } from '@office-start/data-fetching';
import { useIdentity } from '@office-start/identity-service';
import { executeUnifiedStorageDataFlow } from '../data-flows/executeUnifiedStorageDataFlow';
export function useOneDriveGraphStorageQuota(useUsq) {
    var componentContext = useOfficeComponentContext().data;
    var identity = useIdentity().data;
    var sharedContext = useSharedContext().data;
    var query = [
        (useUsq
            ? 'GraphUnifiedStorageQuota'
            : 'OneDriveGraphStorageQuota'),
    ];
    return useQuery(query, function () {
        return useUsq &&
            componentContext &&
            identity &&
            sharedContext &&
            (identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? executeUnifiedStorageDataFlow(componentContext, identity, sharedContext, function (freshData) {
                return queryCache.setQueryData(query, freshData);
            })
            : undefined;
    }, {
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: componentContext && identity && sharedContext,
    });
}
//# sourceMappingURL=useOneDriveGraphStorageQuota.js.map